import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=9c981642&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=ts"
export * from "./ActivityItem.vue?vue&type=script&lang=ts"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=9c981642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c981642",
  null
  
)

export default component.exports